export default "__VITE_ASSET__gO62i4xw__"